export const state = () => ({
    list: [],
});

export const mutations = {
    change(state, newList) {
        state.list = newList;
    },
};

export const getters = {
    get(state) {
        return state.list;
    },
};

export const actions = {
    async init({ commit }) {
        try {
            let { data } = await this.$axios.get("/api/pages/list");
            commit("change", data);
        } catch (error) {
            console.log(`error =>`, error);
        }
    },
};
